<template>
    <div class="page-wrapper">
        <project-payment-methods
                v-if="paymentMethods.length !== 0"
                :paymentMethods="paymentMethods"
        />
    </div>
</template>

<script>

import ProjectPaymentMethods from '../components/ProjectPaymentMethods/ProjectPaymentMethods.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProjectPaymentMethodsView',

  components: { ProjectPaymentMethods },

  computed: {
    ...mapGetters({
      paymentMethods: 'project/paymentMethods',
    }),
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectPaymentMethodsView.vue